import { RequestKijshopcdOnly } from '../../../models/api/front/staff-management';
import { ApiBaseFront } from '../api-base-front';
import {APP_CODE} from "../../../containers/initialize";

export class ApiShopPasswordReset extends ApiBaseFront {
  constructor(param: RequestKijshopcdOnly) {
    super(
      'POST',
      '/api/v1/shop/mail/reset_password',
      'JSON',
      { ...param, appCode: APP_CODE },
    );
  };
}